module.exports = __webpack_public_path__ + "img/qufu-name.f891bceb.png";